import { render } from "./EditorMenuItem.vue?vue&type=template&id=c980fd12"
import script from "./EditorMenuItem.vue?vue&type=script&lang=js"
export * from "./EditorMenuItem.vue?vue&type=script&lang=js"

import "./EditorMenuItem.vue?vue&type=style&index=0&id=c980fd12&lang=css"

import exportComponent from "D:\\Code_projects\\maria_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__